import { GET_SHIPPING, GET_SHIPPING_BY_ID, GET_SHIPPING_LIST, GET_SHIPPINGS } from './ApiConstants';
import api from './ApiHandler';

export const getShippingsByPage = async (payload: any) => {
  return await api.get(GET_SHIPPINGS, { params: payload });
};

export const getShippingList = async (payload: any) => {
  return await api.get(GET_SHIPPING_LIST, { params: payload });
};

export const getShippingById = async (payload: any) => {
  return await api.get(GET_SHIPPING_BY_ID, { params: payload });
};